"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsWidgetTrendsAdjustUnitEnum = void 0;
var StatsWidgetTrendsAdjustUnitEnum;
(function (StatsWidgetTrendsAdjustUnitEnum) {
    StatsWidgetTrendsAdjustUnitEnum["DAY"] = "DAY";
    StatsWidgetTrendsAdjustUnitEnum["WEEK"] = "WEEK";
    StatsWidgetTrendsAdjustUnitEnum["MONTH"] = "MONTH";
})(StatsWidgetTrendsAdjustUnitEnum = exports.StatsWidgetTrendsAdjustUnitEnum || (exports.StatsWidgetTrendsAdjustUnitEnum = {}));
